import dynamic from 'next/dynamic';
import { Section } from '~/components/common/section';
const CountUp = dynamic(() => import('react-countup'), {
   ssr: false,
});

type StatisticsWidgetProps = {
   title: React.ReactNode;
   count: number;
   icon: string;
   suffix?: string;
   children?: React.ReactNode;
   isCurrency?: boolean;
};
export const StatisticsWidget = ({
   count,
   icon,
   title,
   suffix,
   children,
   isCurrency,
}: StatisticsWidgetProps) => {
   return (
      <Section className="h-28 py-2 flex items-center justify-center">
         <div className="w-full  space-y-2">
            <img alt="" src={icon} className="mx-auto" />
            <span className="block text-xs text-grey-200">{title}</span>
            <div className="text-lg font-bold leading-none">
               <CountUp
                  duration={count > 1000 ? 1.5 : count > 100 ? 1 : 0.5}
                  start={0}
                  end={count}
                  separator=","
                  decimal={'.'}
                  decimals={isCurrency && count > 0 ? 2 : 1}
                  suffix={isCurrency ? ' SR' : suffix}
                  className="!m-0 !p-0"
               />
            </div>
            {children}
         </div>
      </Section>
   );
};
